<style lang="less" scoped>
.books {
  height: 100%;
 // width: 100%;
  margin: 0 auto;
  //max-width: 1440px;
  //padding: 0px 10px 10px 40px;
  overflow-x: hidden;
  background: rgb(246, 246, 246);
}

.books-nav {
  height: 100%;
  width: 200px;
  background-color: @white;
  position: fixed;
  text-align: center;
  z-index: 9;

  .reading-back {
    width: 16px;
    height: 28px;
    position: absolute;
    top: 33px;
    left: 50px;
    cursor: pointer;
  }
}

.nav {
  display: inline-block;
  list-style: none;
  vertical-align: middle;
  margin-top: 20px;
  // min-width: 1200px;
  // overflow: hidden;
}

.reference {
  width: 160px;
  height: 160px;
  cursor: pointer;
  float: right;

  img {
    width: 100%;
    height: auto;
  }
}

.nav-btn {
  display: inline-block;
  margin: 0 20px;
  text-align: center;
  font-size: 16px;
  color: @black;
  cursor: pointer;

  a {
    color: #9d9292;
    cursor: pointer;
    font-size: 16px;
    display: block;
    width: 100%;
  }
}

.nav-btn.active,
.nav-btn:hover {
  color: @primary-color;

  a {
    color: @primary-color;
  }
}

.ant-dropdown {
  width: 300px;
  background-color: @body-background;
  border-radius: @border-radius-base;
}

.menu {
  top: 180px;
  padding: 20px;
}

.books-sider {
  width: 200px;
  height: calc(100vh - 140px);
  overflow-y: scroll;
  overflow-x: hidden;
  //min-height: 620px;
  background: #fff;
  //margin-top: 40px;
  padding-bottom: 20px;
  position: fixed;
  border-radius: 12px;

  .books-title {
    background: #FFFFFF;
    color: @primary-color;
    text-align: center;
    font-size: 18px;
    padding: 20px 15px 0px 15px;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;

    .books-name {
      color: @primary-color;
      display: inline-block;
      max-width: 110px; /* 调整为适当的最大宽度 */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      float: left;
    }

    .trigger {
      float: right;
      width: 40px;
      height: 40px;
      margin-top: 3px;
    }
  }

  .books-menu {
    .books-menu-item {
      height: 50px;
      padding-top: 5px;

      .icon {
        height: 25px;
        padding: 0px 9px 0 0;
        margin-top: 8px
      }

      .text {
        font-size: 18px;
       // margin-top: 110px;
        position: absolute;
      }
    }
  }
}

.books-content {
  overflow: initial;
  padding-left: 220px;
}

.books-router {
  overflow: initial;
  //padding-left: 210px;
  //margin-top: 40px;
}

.unit {
  font-size: 20px;
  color: @primary-color;
  line-height: 35px;
  cursor: default;
}

.unit.ant-dropdown-menu-item:hover {
  background-color: white !important;
}

/deep/ .ant-dropdown-menu-submenu-title {
  font-size: 18px;
  line-height: 30px;
}
/deep/ .ant-layout {
  background: white;
}

.lesson {
  font-size: 18px;
  line-height: 30px;
}

.master {
  position: absolute;
  background-color: @disabled-color;
  top: 180px;
  left: 0px;
  width: 100%;
  height: 100%;
}

/deep/ .ant-popover .ant-popover-placement-bottom {
  width: 100%;
}
</style>

<template>
  <a-layout class="books">

    <a-layout class="books-content" :style="{paddingLeft:isNavShow?'0px':'0px'}">
      <a-layout-sider class="books-sider" v-show="isNavShow" collapsible v-model="collapsed" :trigger="null">
        <a-layout>
          <div class="books-title">
            <span class="books-name" v-show="!collapsed"> {{ lessonName }} </span>
            <a-icon
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="toggleCollapsed"/>
          </div>
          <a-menu
              mode="inline"
              :default-selected-keys="[activeMenuItem]"
              :selected-keys="[activeMenuItem]"
              :style="{ height: '100%', borderRight: 0}"
              @click="handleClick"
              class="books-menu"
          >
            <a-menu-item :key=item.name v-for="(item, idx) in tabs" class="books-menu-item"
                         :title="item.title">
              <router-link :to="{ name: item.name, params: {id: styleId} }">
                <div>
                  <han-icon v-show="activeMenuItem !== item.name" :type="item.iType1"
                            class="icon"/>
                  <han-icon v-show="activeMenuItem === item.name" :type="item.iType2"
                            class="icon"/>
                  <span class="text" v-show="!collapsed">{{ item.title }}</span>
                </div>

              </router-link>
            </a-menu-item>
          </a-menu>
          <!--          <div style="height: 60px;padding-top: 10px;background: #FFFFFF">-->
          <!--            <div class="reference" @click="reference_to"><img src="../../../src/assets/image/re_0.png" alt=""></div>-->
          <!--          </div>-->

        </a-layout>
      </a-layout-sider>
    </a-layout>
    <a-layout-content class="books-router" :style="{ paddingLeft: collapsed?'90px':'210px' }">
      <a-breadcrumb style="margin: 0px 0px 20px 20px;width:100%;" v-show="isNavShow">
        <a-breadcrumb-item style="font-size: 16px">在线备课</a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/'">目录</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="{ name: this.activeMenuName, params: {id: styleId} }"> {{
              this.activeMenuTitle
            }}
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px" v-if="isTaskFeedBack">任务反馈</a-breadcrumb-item>
      </a-breadcrumb>
      <router-view ref="childmain"/>
    </a-layout-content>
  </a-layout>
</template>
<script>
import shareState from 'utils/shareState.js'
import HanIcon from 'components/Icon.vue'

export default {
  name: 'Books',
  components: {
    HanIcon
  },

  data () {
    return {
      auHeight: '100%',
      activeMenuItem: 'Attainment',
      activeMenuTitle: '',
      activeMenuName: '',
      collapsed: false,
      isNavShow: false,
      auVisible: false,
      preOpenKeys: ['1'],
      openKeys: ['1'],
      selectedKeys: localStorage.getItem('lessonNKey') || 'Attainment',
      shareData: shareState.state,
      lessonName: localStorage.getItem('lessonName') || localStorage.getItem('disPlayName'),
      audioPath: '',
      audioPhoto: '',
      audioParagraph: [],
      colorItem: null,
      styleId: '',
      isBookList: true,
      isTaskFeedBack: false,
      tabs: []
    }
  },
  watch: {
    $route () {
      this.selectedKeys = localStorage.getItem('lessonNKey') || 'Attainment'
      this.shouldMatch()
      this.setShowPane()
      this.lessonName = localStorage.getItem('lessonName') || localStorage.getItem('disPlayName')
      console.log('$route--', this.selectedKeys)
    }
  },
  methods: {
    toggleCollapsed () {
      this.collapsed = !this.collapsed
      localStorage.setItem('LessonCollapsed', this.collapsed ? '1' : '0')
      console.log('点击-在线备课-', this.collapsed)
      // this.openKeys = this.collapsed ? [] : this.preOpenKeys
    },
    onBack () {
      // this.$router.push({ path: `/books/learning-pre/${this.$route.params.id}` })
      // this.$router.push({ path: `/books/NewLessonResources/` })
      this.$router.go(-1)
    },
    shouldMatch () {
      const that = this
      this.styleId = this.$route.params.id
      this.activeMenuItem = this.$route.name
      if (this.activeMenuItem === 'taskFeedBack') {
        // 学习反馈时选中学习任务
        this.activeMenuItem = 'StudyTask'
      }
      console.log('activeMenuItem', this.activeMenuItem)
      this.isNavShow = !(
      // 不显示左边的导航
      // this.activeMenuItem === 'NewLessonResources' ||
        this.activeMenuItem === 'Books' ||
          this.activeMenuItem === 'StudyTaskRecommend' ||
          this.activeMenuItem === 'PrepareRecommend' ||
          this.activeMenuItem === 'BeiKe' ||
          this.activeMenuItem === 'LearningPre' ||
          this.activeMenuItem === 'ActiveUnit' ||
          this.activeMenuItem === 'StudyTaskHistory' ||
          this.activeMenuItem === 'TitleRecommend' ||
          this.activeMenuItem === 'TitleHistory' ||
          this.activeMenuItem === 'WritingRecommend' ||
          this.activeMenuItem === 'WritingHistory' ||
          this.activeMenuItem === 'WritingGuideDetail'
      )
      if (this.isNavShow) {
        this.$nextTick(() => {
          console.log('shouldMatch', this.$route.fullPath)
          if (this.$route.fullPath.includes('book')) {
            shareState.setPrepareLocation(this.$route.fullPath)
          }
          const filter = that.tabs.filter(function (item) {
            return item.name === that.activeMenuItem
          })
          console.log('filter', filter)
          if (filter && filter.length > 0) {
            this.activeMenuTitle = filter[0].title
            this.activeMenuName = filter[0].name
          }
        })
      }
      // 是否学习反馈
      this.isTaskFeedBack = (this.$route.path.includes('/taskFeedBack'))
      console.log(this.$route.path)
      console.log(this.$route.path.includes('/taskFeedBack'))
    },
    getMenu () {
      if (this.shareData.menuList.length > 0) return false
      const bookId = localStorage.getItem('syzg-bookId')
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/styleList',
        body: { bookId: bookId }
      })
        .loading(() => (this.loading = true))
        .done((res) => {
          // console.log(res)
          shareState.setMenuList(res.resultData)
          this.setArticleInfo(res.resultData, this.$route.params.id)
          this.setShowPane()
        })
    },
    setShowPane () {
      if (this.shareData.menuList.length <= 0) return false
      let b = false
      const curLess = this.shareData.menuList.filter((item) => {
        return item.id === this.$route.params.id
      })
      if (curLess[0] && curLess[0].classicalVernacular === 2 && this.activeMenuItem === 'ReadingBook') {
        b = true
      }
      shareState.setShowIconVisible(b)
    },
    setArticleInfo (menu, id) {
      let sTitle = ''
      const arr = menu.filter((item) => {
        if (Number(item.genreType) === 5 && item.completeBookList.length > 0) {
          const sarr = item.completeBookList.filter((cItem) => {
            return cItem.id === id
          })
          if (sarr.length > 0) {
            sTitle = '-' + sarr[0].orgDisplayName
            return item
          }
        } else {
          return item.id === id
        }
      })
      if (arr.length === 0) return false
      shareState.setOrgDisplayName(arr[0].orgDisplayName + sTitle)
      shareState.setAuthor(arr[0].author)
      shareState.setGenreType(arr[0].genreType)
      shareState.setStyleId(arr[0].id)
      if (arr[0].completeBookList.length === 0) return false
      shareState.setcompleteBookList(arr[0].completeBookList)
      // console.log('setArticleInfo', arr[0])
    },
    goArticle (item) {
      if (Number(item.isClickable) === 0) return false
      const reg = /\/\d+$/
      const cPath = this.$route.path.replace(reg, '')
      shareState.setAuthor(item.author)
      shareState.setGenreType(item.genreType)
      shareState.setStyleId(item.id)
      if (item.completeBookList.length > 0) {
        shareState.setOrgDisplayName(item.orgDisplayName + '-')
        shareState.setcompleteBookList(item.completeBookList)
        this.$router.push({ path: `${cPath}/${item.completeBookList[0].id}` })
        return
      }
      if (item.genreType === 6) {
        this.$router.push({ path: '/books/active-unit/' })
        return
      }
      shareState.setOrgDisplayName(item.orgDisplayName)
      this.$router.push({ path: `${cPath}/${item.id}` })
    },
    changeTextColor (item) {
      if (this.activeMenuItem !== 'ReadingBook') return
      this.$refs.childmain.changeTextColor(item)
    },
    changeParagraph (args) {
      this.$refs.childmain.changeParagraph(args)
    },
    handleClick (e) {
      console.log('click', e.key)
      localStorage.setItem('lessonNKey', e.key)
    }
  },

  mounted () {
    this.tabs = [
      {
        name: 'Attainment',
        iType1: 'svg1',
        iType2: 'svg11',
        title: '学科素养',
        position: 0
      },
      {
        name: 'ZhunBei',
        iType1: 'svg3',
        iType2: 'svg33',
        title: '学前准备',
        position: 1
      },
      {
        name: 'TextReadGuide',
        iType1: 'svg5',
        iType2: 'svg55',
        title: '课文导读',
        position: 2
      },
      {
        name: 'StudyTask',
        iType1: 'svg4',
        iType2: 'svg44',
        title: '学习任务',
        position: 3
      },
      {
        name: 'TitleAnalysis',
        iType1: 'svg6',
        iType2: 'svg66',
        title: '标题解析',
        position: 4
      },
      {
        name: 'RelatedArticle',
        iType1: 'relart1',
        iType2: 'relart2',
        title: '相关阅读',
        position: 5
      },
      {
        name: 'WritingGuide',
        iType1: 'svg7',
        iType2: 'svg77',
        title: '写作指导',
        position: 6
      },
      {
        name: 'SmallClass',
        iType1: 'svg9',
        iType2: 'svg99',
        title: '添加微课',
        position: 7
      },
      {
        name: 'NewLessonResources',
        iType1: 'svg10',
        iType2: 'svg1010',
        title: '参考教案',
        position: 8
      }
    ]
    this.shouldMatch()
    this.getMenu()

    const prepareLocation = this.shareData.prepareLocation
    console.log('location', prepareLocation)
    console.log('location', this.shareData)

    this.lessonName = localStorage.getItem('lessonName') || localStorage.getItem('disPlayName')
    this.selectedKeys = localStorage.getItem('lessonNKey')
    console.log('location--', this.selectedKeys)
    if (prepareLocation && prepareLocation !== '/books/' && prepareLocation !== '/') {
      this.$router.push(prepareLocation)
    }
  }
}
</script>
